export default function searchFormPopup() {
    const btnOpener = $('.search-opener');
    const btnClose = $('.header-search-form .reset');

    let toggleSearch = () => {
        $('#autoSuggestSearchMobile').html('');
        $('body').toggleClass('search-active');
    }

    btnClose.on('click', toggleSearch);
    btnOpener.on('click', toggleSearch);
}
